import { Flex, Text } from "@jsq/ds/core";
import { Icon, IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { statusContainer } from "./styles_vanilla.css";
import type { CaseStatus } from "../../types";

type StatusConfig = {
  displayText: string;
  iconType: IconType;
  iconColor?: Colors;
};

const getStatusConfig = (status: CaseStatus): StatusConfig => {
  switch (status) {
    case "PENDING_REVIEW":
      return {
        displayText: "Pending review",
        iconType: "magnifying-glass-plus",
        iconColor: Colors.Neutral700,
      };
    case "IN_REVIEW":
      return {
        displayText: "In review",
        iconType: "arrows-rotate",
        iconColor: Colors.Neutral700,
      };
    case "CLOSED":
      return {
        displayText: "Closed",
        iconType: "flag-checkered",
        iconColor: Colors.Neutral900,
      };
    default:
      return {
        displayText: "--",
        iconType: "circle",
        iconColor: Colors.Neutral700,
      };
  }
};

type StatusRendererProps = {
  status?: CaseStatus;
};

export const StatusRenderer = ({ status }: StatusRendererProps) => {
  if (!status) return null;
  const { displayText, iconType, iconColor = Colors.Neutral700 } = getStatusConfig(status);

  return (
    <Flex alignItems="center" gap={8} className={statusContainer}>
      <Icon type={iconType} color={iconColor} data-testid="case-status-icon" />
      <Text color={iconColor}>{displayText}</Text>
    </Flex>
  );
};
